module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__verification__a-e978793b40a3bf8fcd9578b57d0a55bb.svg";